import React from 'react';
import { Message } from 'semantic-ui-react';

/** Matches the negative message TextInput renders under an invalid field. */
export const FieldErrorMessage = ({ message }: { message?: string }) =>
  message ? (
    <Message negative>
      <p>{message}</p>
    </Message>
  ) : null;
